import React from 'react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="relative bg-black border-t border-white/10">
      {/* Main Footer */}
      <div className="container mx-auto px-4 py-8 md:py-16">
        <div className="text-center">
          <div className="mb-4 flex items-center justify-center gap-3">
            <img 
              src="/images/vf-logo.png" 
              alt="Vital Fusion Coaching Logo" 
              className="h-12 w-12 object-contain"
            />
            <span className="text-3xl font-bold bg-gradient-to-r from-[#5F9BC7] to-[#FFE7AB] bg-clip-text text-transparent">
              Vital Fusion Coaching
            </span>
          </div>
          <p className="text-gray-400 max-w-2xl mx-auto">
            Transform your body and life with sustainable fitness coaching. 
            Real results with a process you can stick to for life.
          </p>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="container mx-auto px-4 py-6">
          <div className="text-center">
            <p className="text-gray-400 text-sm">
              © {currentYear} Vital Fusion Coaching. All rights reserved.
            </p>
          </div>
        </div>
      </div>

      {/* Background Glow */}
      <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 w-full h-32 bg-gradient-to-t from-[#5F9BC7]/5 to-transparent pointer-events-none"></div>
    </footer>
  );
};

export default Footer;
